import React from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'core/utils/dayjs';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import MerchantNoRebateLabel from 'core/modules/MerchantNoRebateLabel/MerchantNoRebateLabel';
import { selectGiftGuideConfig } from '../selectors';

import './GiftGuideItem.scss';

function GiftGuideItem({
  merchant, id: offerId, assets, stopDatetime, couponCode, isOngoing,
}) {
  const {
    rebateOptions, giftGuideFeaturedDeals: { api: { options: apiOptions } }, shouldTrackInitialParams,
  } = useSelector(selectGiftGuideConfig);
  const { sectionId } = apiOptions;
  const { _150x150, imageAlternateText, rolloverCopy } = assets;
  const {
    name, id, logoUrls, rebate, showRebate,
  } = merchant;
  const expiresToDisplay = dayjs.parseZone(stopDatetime).format('M/DD/YY');

  return (
    <div className="mn_giftGuideItemWrap mn_favoriteItemWrap" role="listitem">
      <FavoriteIcon merchantId={id} merchantName={name} />
      <OfferOverlayLink
        merchantId={id}
        merchantName={name}
        offerId={offerId}
        sectionId={sectionId}
        shouldTrackInitialParams={shouldTrackInitialParams}
      >
        <div className="mn_merchantImageWrap">
          <img className="mn_merchantImage" src={_150x150} alt={imageAlternateText} />
        </div>
        <div className="mn_merchantWrap">
          <div className="mn_merchantLogo">
            <img src={logoUrls._88x31} alt={name} />
          </div>
          <div className="mn_offerDetails">
            <div className="mn_copyWrap">
              <p>{rolloverCopy}</p>
            </div>
            <div className="mn_promoCodeWrap">
              {couponCode &&
                <>
                  <p>Use code:</p>
                  <p className="mn_promoCode">{couponCode}</p>
                </>
              }
            </div>
            <p className="mn_expirationDate">
              {isOngoing ? <>Ongoing</> : <>Valid thru {expiresToDisplay}</>}
            </p>
          </div>
          <div className="mn_rebateWrap">
            {showRebate ? <PremierMerchantRebate {...rebate} {...rebateOptions} /> : <MerchantNoRebateLabel />}
          </div>
        </div>
      </OfferOverlayLink>
    </div>
  );
}

export default GiftGuideItem;
